<button
    type="button"
    class="cursor-pointer text-shui-text-subtle flex items-center gap-2 bg-transparent border-none p-0"
    (click)="toggleTheme()"
    [attr.aria-label]="('common.header.theme' | translate) + ': ' + (actionThemeKey() | translate)"
    [attr.title]="('common.header.theme' | translate) + ': ' + (actionThemeKey() | translate)"
>
    <sh-icon [icon]="themeIcon()" size="s" class="text-shui-text-subtle"></sh-icon>
    @if (showLabel()) {
        <span class="cursor-pointer text-base text-shui-text-subtle flex items-center gap-2 py-2">{{
            themeTextKey() | translate
        }}</span>
    }
</button>
